import React from "react";

const SaveCardCheckbox = ({ checked, onChange, disabled }) => {
    return (
        <div className="save-card">
            <label htmlFor="save-card">
                <input
                    id="save-card"
                    name="save-card"
                    className="checkbox-input"
                    type="checkbox"
                    checked={checked}
                    onChange={onChange}
                    disabled={disabled}
                />
                <div className="checkbox-container">
                    <i
                        className={`ui_check-mark ${checked ? "checked" : ""}`}
                    />
                </div>
                Save card
            </label>
        </div>
    );
};

export default SaveCardCheckbox;
